const reportError = (error, info) => {
  if (error || info) {
    return Promise.reject(new Error(`Error: ${error} --- Info: ${info}`));
  }

  return Promise.resolve({ success: true });
};

// in a real app this would report an error

// but this isn't a real app and is only here to be mocked.

export { reportError };
